(() => {
  if (window.chokoCollectionReady) return;
  window.chokoCollectionReady = true;
  const prepareLink = (link) => {
    const destination = new URL(link.getAttribute('href'), window.location.origin);
    destination.search = window.location.search;
    destination.searchParams.delete('page');
    if (link.hasAttribute('data-choko-budget')) {
      destination.pathname = window.location.pathname;
      destination.searchParams.delete('filter.v.price.gte');
      destination.searchParams.delete('filter.v.price.lte');
      if (link.dataset.min) destination.searchParams.set('filter.v.price.gte', link.dataset.min);
      if (link.dataset.max) destination.searchParams.set('filter.v.price.lte', link.dataset.max);
    }
    if (link.hasAttribute('data-choko-clear-all')) {
      for (const key of [...destination.searchParams.keys()]) {
        if (key.startsWith('filter.')) destination.searchParams.delete(key);
      }
    }
    link.href = destination.href;
  };
  const sync = () => {
    document.querySelectorAll('[data-choko-filter-link],[data-choko-clear-all]').forEach(prepareLink);
    const params = new URLSearchParams(window.location.search);
    const value = (key) => {
      const raw = params.get(key);
      return raw && Number.isFinite(Number(raw)) ? String(Number(raw)) : '';
    };
    document.querySelectorAll('[data-choko-budget]').forEach((link) => {
      const selected = (link.dataset.min || '') === value('filter.v.price.gte') && (link.dataset.max || '') === value('filter.v.price.lte');
      if (selected) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-choko-filter-link],[data-choko-clear-all]');
    if (link) {
      prepareLink(link);
      if (link.hasAttribute('data-choko-clear-all') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(link.href);
      }
    }
  }, true);
  const preservePagination = (event) => {
    const link = event.target.closest('.pagination a[href]');
    if (!link) return;
    const destination = new URL(link.href);
    const page = destination.searchParams.get('page');
    destination.search = window.location.search;
    destination.searchParams.delete('page');
    if (page) destination.searchParams.set('page', page);
    link.href = destination.href;
  };
  ['click', 'focusin', 'pointerover'].forEach((name) => document.addEventListener(name, preservePagination, true));
  window.addEventListener('popstate', sync);
  const grid = document.getElementById('ProductGridContainer');
  if (grid) new MutationObserver(sync).observe(grid, {childList: true});
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
